/**
 * 金额显示
 */

import { trimTailDotAndZero } from '@/utils/util';
import BigNumber from 'bignumber.js';

const formatAmount = (amount: string | number) => {
  if (BigNumber(amount).gt(0) && BigNumber(amount).lt(0.00000001)) {
    return '< 0.00000001';
  }
  return trimTailDotAndZero(BigNumber(amount).toFixed(8, 7));
};

interface AmountProps {
  amount: string | number;
  symbol: string;
}

export default function Amount({ amount, symbol }: AmountProps) {
  return (
    <span>
      {formatAmount(amount)} {symbol}
    </span>
  );
}
